import React from 'react';
import { Box, Typography, Link } from '@material-ui/core';
import PropTypes from 'prop-types';

import { useEmptyStateStyles } from './styles';
import EmptyStateIcon from '../../../../components/common/emptyStateIcons/emptyStateTickets.svg';
import Message from '../../../common/Message';
import { useHistory } from 'react-router';
import { PURCHASE_ROUTE } from '../../../../constants/Routes';

const EmptyState = (props) => {
  const { mobile } = props;
  const history = useHistory();
  const classes = useEmptyStateStyles({ mobile });

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      marginTop="40px"
      flex={1}
      overflow="auto"
      className={classes.emptyState}
    >
      <img src={EmptyStateIcon} className={classes.imageEmptyState} />
      <Typography variant="h4" className={classes.titleEmptyState}>
        Aún no has realizado requerimientos
      </Typography>
      <Typography variant="h5" className={classes.subtitleEmptyState}>
        Tus solicitudes anteriores no están disponibles en este momento
        {!mobile && <br />}
        pero las estamos gestionando
        <br />
        ¡Pronto recibirás noticias!
      </Typography>
      <div className={classes.infoMessage}>
        <Message
          fullRounded
          severity="info"
          message={
            <div>
              Si tienes inconvenientes con tus productos, debes realizar un
              reporte en la sección <strong>Compras realizadas</strong>. Si
              tienes una solicitud de otro tipo, debes ingresar a la sección{' '}
              <strong>Realizar solicitud</strong>.
            </div>
          }
        />
      </div>
      {!mobile && (
        <Link
          href="#"
          onClick={() => history.push(PURCHASE_ROUTE)}
          className={classes.goPurchases}
        >
          Ir a compras realizadas
        </Link>
      )}
    </Box>
  );
};

EmptyState.propTypes = {
  mobile: PropTypes.bool,
};

export default EmptyState;
